// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5993":"dcd5ad3f","8130":"2f8906cd","8665":"dcd5ad3f"}[chunkId] + ".chunk.css";
};